(function () {
  'use strict';

  var ADDON_SIZE = 2;
  var addonProducts = [];
  var addonPage = 0;
  var isOpen = false;

  var triggerEl, panelEl, closeBtn, continueBtn;
  var itemsEl, countEl, subtotalEl;
  var addonsGridEl, addonPrevBtn, addonNextBtn;

  function init() {
    triggerEl    = document.querySelector('.site-header-cart');
    panelEl      = document.getElementById('elohim-cd');
    closeBtn     = document.getElementById('elohim-cd-close');
    continueBtn  = document.getElementById('elohim-cd-continue');
    itemsEl      = document.getElementById('elohim-cd-items');
    countEl      = document.getElementById('elohim-cd-count');
    subtotalEl   = document.getElementById('elohim-cd-subtotal');
    addonsGridEl = document.getElementById('elohim-cd-addons');
    addonPrevBtn = document.getElementById('elohim-cd-ap');
    addonNextBtn = document.getElementById('elohim-cd-an');

    if (!triggerEl || !panelEl) return;

    triggerEl.addEventListener('mouseenter', function() {
      // Desktop hover: only open if not a touch device
      if (!('ontouchstart' in window)) open();
    });

    // Mobile / touch: click toggles the drawer instead of navigating to /cart
    triggerEl.addEventListener('click', function(e) {
      if (window.innerWidth <= 1023 || ('ontouchstart' in window)) {
        e.preventDefault();
        if (isOpen) { close(); } else { open(); }
      }
    });

    closeBtn    && closeBtn.addEventListener('click', close);
    continueBtn && continueBtn.addEventListener('click', close);

    // Close when tapping outside the panel on mobile
    document.addEventListener('click', function(e) {
      if (isOpen && !panelEl.contains(e.target) && !triggerEl.contains(e.target)) {
        close();
      }
    });

    addonPrevBtn && addonPrevBtn.addEventListener('click', function () {
      if (addonPage > 0) { addonPage--; renderAddons(); }
    });
    addonNextBtn && addonNextBtn.addEventListener('click', function () {
      if ((addonPage + 1) * ADDON_SIZE < addonProducts.length) { addonPage++; renderAddons(); }
    });

    window.addEventListener('cartcount:update', function () {
      if (isOpen) fetchCart();
    });

    window.addEventListener('resize', function () {
      if (isOpen) position();
    });

    fetchAddons();
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    position();
    panelEl.setAttribute('aria-hidden', 'false');
    panelEl.classList.add('elohim-cd--open');
    fetchCart();
  }

  function close() {
    isOpen = false;
    panelEl.setAttribute('aria-hidden', 'true');
    panelEl.classList.remove('elohim-cd--open');
  }

  function position() {
    // Mobile: CSS bottom-sheet handles positioning — clear any inline styles
    if (window.innerWidth <= 480) {
      panelEl.style.top   = '';
      panelEl.style.right = '';
      panelEl.style.left  = '';
      return;
    }
    var rect = triggerEl.getBoundingClientRect();
    var rightVal = Math.max(0, window.innerWidth - rect.right);
    // Prevent going off left edge
    if (window.innerWidth - rightVal - 380 < 8) rightVal = Math.max(0, window.innerWidth - 388);
    panelEl.style.top   = (rect.bottom + 8) + 'px';
    panelEl.style.right = rightVal + 'px';
    panelEl.style.left  = '';
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function shopifyImg(url, width) {
    if (!url) return '';
    return url.split('?')[0] + '?width=' + width;
  }

  function renderCart(cart) {
    var n = cart.item_count;
    countEl.textContent    = n + ' Item' + (n !== 1 ? 's' : '');
    subtotalEl.textContent = money(cart.total_price);

    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="elohim-cd__empty">Your cart is empty.</p>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = shopifyImg(item.image, 120);
      return '<div class="elohim-cd__item">'
        + (img ? '<img class="elohim-cd__item-img" src="' + esc(img) + '" alt="' + esc(item.title) + '">' : '<div class="elohim-cd__item-img"></div>')
        + '<div class="elohim-cd__item-info">'
        + '<div class="elohim-cd__item-title">' + esc(item.product_title) + '</div>'
        + '<div class="elohim-cd__item-meta">' + money(item.price) + ' /ea.&nbsp;&nbsp;Qty: ' + item.quantity + '</div>'
        + '</div></div>';
    }).join('');
  }

  function fetchAddons() {
    fetch('/collections/all/products.json?limit=8&sort_by=best-selling')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        addonProducts = data.products || [];
        renderAddons();
      })
      .catch(function () {});
  }

  function renderAddons() {
    if (!addonsGridEl) return;
    var start = addonPage * ADDON_SIZE;
    var slice = addonProducts.slice(start, start + ADDON_SIZE);

    addonsGridEl.innerHTML = slice.map(function (p) {
      var img   = shopifyImg(p.images && p.images[0] ? p.images[0].src : '', 200);
      var v     = p.variants && p.variants[0];
      var price = v ? money(v.price) : '';
      var avail = v ? v.available : false;
      return '<div class="elohim-cd__addon-card">'
        + '<a href="/products/' + p.handle + '" class="elohim-cd__addon-img-wrap">'
        + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '')
        + '</a>'
        + '<div class="elohim-cd__addon-body">'
        + '<a href="/products/' + p.handle + '" class="elohim-cd__addon-title">' + esc(p.title) + '</a>'
        + '<div class="elohim-cd__addon-price">' + price + '</div>'
        + (avail
            ? '<form action="/cart/add" method="post" class="atc-form"><input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="elohim-cd__addon-atc">Add to Cart</button></form>'
            : '<a href="/products/' + p.handle + '" class="elohim-cd__addon-atc elohim-cd__addon-atc--oos">View Product</a>')
        + '</div></div>';
    }).join('');

    if (addonPrevBtn) addonPrevBtn.disabled = addonPage === 0;
    if (addonNextBtn) addonNextBtn.disabled = (addonPage + 1) * ADDON_SIZE >= addonProducts.length;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
